import type { BookingPaymentDetails } from '../../types/api/v1/obt/pnr/payment';
import type {
  AirBookingPaymentSetupId,
  AirExchangePaymentSetupId,
  AirPostBookingPaymentSetupId,
} from '../../types/flight';
import type { ListBookingPaymentSourcesResponse } from '../../types/api/v2/obt/model/list-booking-payment-sources-response';
import type { IPaymentSetupRequestInfo } from '../../queries/payment';
import type { ITraveler } from '../../types/traveler';
import { getPaymentSetupRequestForPaymentSourceId } from './getPaymentSetupRequestForPaymentSourceId';
import { getValidPaymentSourcesForPaymentSetup } from './getValidPaymentSourcesForPaymentSetup';

interface GetPaymentSetupRequestsProps {
  bookingPaymentDetails: BookingPaymentDetails | null;
  primaryTraveler: ITraveler | null;
  listBookingPaymentSourcesResponse: ListBookingPaymentSourcesResponse | null;
  paymentSetupId: AirBookingPaymentSetupId | AirExchangePaymentSetupId | AirPostBookingPaymentSetupId | null;
}

export function getPaymentSetupRequests({
  bookingPaymentDetails,
  primaryTraveler,
  listBookingPaymentSourcesResponse,
  paymentSetupId,
}: GetPaymentSetupRequestsProps): IPaymentSetupRequestInfo[] | null {
  if (!bookingPaymentDetails || !primaryTraveler || !paymentSetupId || !listBookingPaymentSourcesResponse) {
    return null;
  }

  const validPaymentSources = getValidPaymentSourcesForPaymentSetup(
    bookingPaymentDetails,
    listBookingPaymentSourcesResponse,
  );

  const paymentSetupRequests: IPaymentSetupRequestInfo[] = validPaymentSources
    .map((source) => {
      const setupRequest = getPaymentSetupRequestForPaymentSourceId({
        source,
        primaryTraveler,
        paymentSetupId,
      });

      if (!setupRequest) {
        return null;
      }

      return { request: setupRequest, paymentSourceId: source.id };
    })
    .filter((request): request is IPaymentSetupRequestInfo => !!request);

  return paymentSetupRequests;
}
